export function LandingFooter() {
  return (
    <footer className="py-8 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 text-center text-sm text-gray-600">
        <div>© 2025 Tomoro AI. Full Stack Template.</div>
      </div>
    </footer>
  );
}